var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "upload-a",
    d: "M6.29289322,0.292893219 C6.68341751,-0.0976310729 7.31658249,-0.0976310729 7.70710678,0.292893219 C8.09763107,0.683417511 8.09763107,1.31658249 7.70710678,1.70710678 L5.70710678,3.70710678 C5.31658249,4.09763107 4.68341751,4.09763107 4.29289322,3.70710678 C3.90236893,3.31658249 3.90236893,2.68341751 4.29289322,2.29289322 L6.29289322,0.292893219 Z M0,11 L16,11 L16,13 L0,13 L0,11 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "upload-c",
    d: "M11,3.41421356 L11,12.0014708 C11,12.5529433 10.5522847,13 10,13 C9.44771525,13 9,12.5529433 9,12.0014708 L9,3.41421356 L6.70710678,5.70710678 C6.31658249,6.09763107 5.68341751,6.09763107 5.29289322,5.70710678 C4.90236893,5.31658249 4.90236893,4.68341751 5.29289322,4.29289322 L9.29289322,0.292893219 C9.68341751,-0.0976310729 10.3165825,-0.0976310729 10.7071068,0.292893219 L14.7071068,4.29289322 C15.0976311,4.68341751 15.0976311,5.31658249 14.7071068,5.70710678 C14.3165825,6.09763107 13.6834175,6.09763107 13.2928932,5.70710678 L11,3.41421356 Z M18,16 L18,10 C18,9.44771525 18.4477153,9 19,9 C19.5522847,9 20,9.44771525 20,10 L20,17 C20,17.5522847 19.5522847,18 19,18 L1,18 C0.44771525,18 0,17.5522847 0,17 L0,10 C0,9.44771525 0.44771525,9 1,9 C1.55228475,9 2,9.44771525 2,10 L2,16 L18,16 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "upload-b",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#upload-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    fillRule: "nonzero",
    xlinkHref: "#upload-a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFA0A0",
    mask: "url(#upload-b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(-4 -6)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "upload-d",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#upload-c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#upload-c"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#7600FF",
    mask: "url(#upload-d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    transform: "translate(-2 -3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.1fd83ae8627d45e784eff18cf3715acb.svg";
export { ForwardRef as ReactComponent };